import { UserLayout } from '@/layouts'
import errorPage from '@/views/exception/500.vue'

/**
 * 菜单对应的模板,动态import导入失败
 * 增加菜单权限时，需要这里配置一下
 */
export const asyncRouterMap = {
    'workOrder': () => import('@/views/workOrder/WorkOrderList.vue'), // 工单管理
    'personal.info': () => import('@/views/system/Personal.vue'), // 个人中心
    'customer.list': () => import('@/views/customer/CustomerList.vue'), // 客户管理
    'customer.list@xf': () => import('@/views/customer/CustomerListxf.vue'), // 客户续费管理
    'customer.searchScope': () => import('@/views/customer/CustomerBusinessScope.vue'), // 客户经营范围
    'LicenseArchive': () => import('@/views/customer/pigeonhole.vue'), // 营业执照归档
    'PackageArchive': () => import('@/views/customer/PackageList.vue'), // 文件包裹归档
    'AddressRenew': () => import('@/views/customer/AddressRenew.vue'), // 万能支付
    'ObtainExpirationDate': () => import('@/views/customer/ObtainExpirationDate.vue'), // 批量查到期时间
    'CustomerListSimple': () => import('@/views/customer/CustomerListSimple.vue'), // 更新核准日期
    'otherLogistic': () => import('@/views/logistic/OtherLogisticList.vue'), // 顺丰邮寄
    'tasklist': () => import('@/views/customer/tasklist.vue'), // 任务大厅
    'logout.list': () => import('@/views/logout/lst.vue'), // 注销控制台
    'verification.list': () => import('@/views/verification/OtherData.vue'), // 资料审核
    'verificationReimburse': () => import('@/views/verification/Reimburse.vue'), // 报销审核
    'recordVerification': () => import('@/views/recordManagement/Verification.vue'), // 备案审核
    'UserPlatformBalanceCharge': () => import('@/views/verification/UserPlatformBalanceCharge.vue'), // 平台余额充值审核
    'customerVerification': () => import('@/views/verification/customerVerification.vue'), // 客户删除审核
    'publicTransfer': () => import('@/views/financialManagement/publicTransfer.vue'), // 对公账户转账
    'refund': () => import('@/views/verification/refund.vue'), // 退款审核
    'yichangAudit': () => import('@/views/verification/yichangAuditList.vue'), // 资料下载审核
    'customerAttrAdjust': () => import('@/views/verification/customerAttrAdjust.vue'), // 属性调整审核
    'customerLockException': () => import('@/views/verification/customerLockException.vue'), // 锁定异常审核
    'platformManagement': () => import('@/views/platformManagement/PlatformManagement.vue'), // 平台管理
    'restrictedAccess': () => import('@/views/platformManagement/RestrictedAccess.vue'), // 限制准入
    'templateManagement': () => import('@/views/platformManagement/TemplateManagement.vue'), // 平台模板库管理
    'addressNumberManagement': () => import('@/views/system/AddressNumberManagement.vue'), // 地址编号管理
    'userManagement': () => import('@/views/userManagement/UserManagement.vue'), // 用户管理
    'allAuthorization': () => import('@/views/userManagement/AllAuthorityLst.vue'), // 用户权限分组
    'FwsDailiHetongList': () => import('@/views/userManagement/FwsDailiHetongList.vue'),
    'recharge': () => import('@/views/financialManagement/Recharge.vue'), // 充值明细
    'consumption': () => import('@/views/financialManagement/consumption.vue'), // 消费明细
    'commission': () => import('@/views/financialManagement/commission.vue'), // 佣金明细
    'commissionAudit': () => import('@/views/financialManagement/commissionAudit.vue'), // 佣金提现记录
    'dealerTixianList': () => import('@/views/financialManagement/dealerTixianList.vue'), // 推荐人提现记录
    'serviceTixianAudit': () => import('@/views/financialManagement/serviceTixianAudit.vue'), // 服务商提现记录
    'customerOrderInvoice': () => import('@/views/financialManagement/customerOrderInvoice.vue'), // 服务商提现记录
    'MyCouponsList': () => import('@/views/coupons/MyCouponsList.vue'), // 我的优惠券
    'platformBalance': () => import('@/views/financialManagement/UserPlatformBalance.vue'), // 平台余额
    'UserKoukuan': () => import('@/views/financialManagement/UserKoukuan.vue'), // 平台扣款
    'pettycash': () => import('@/views/financialManagement/pettycash.vue'), // 备用金
    'operate': () => import('@/views/statistics/operate.vue'), // 运营情况
    'YwtbList': () => import('@/views/statistics/YwtbList.vue'), // 一网通办运营情况
    'Taglist': () => import('@/views/statistics/Taglist.vue'), // 标签管理
    'filingInformation': () => import('@/views/recordManagement/FilingInformation.vue'), // 渠道客戶备案
    'activity': () => import('@/views/activity/Activity.vue'), // 活动中心
    'inventory': () => import('@/views/activity/Inventory.vue'), // 购买库存地址
    'freequeue': () => import('@/views/activity/Freequeue.vue'), // 排队免单
    'FreeActivity': () => import('@/views/activity/FreeActivity.vue'), // 排队免单活动管理
    'notificationManagement': () => import('@/views/system/NotificationManagement.vue'), // 群发工具
    'permissionMap': () => import('@/views/systemrbac/permissionmap.vue'), // 权限管理
    'rbacpermissions': () => import('@/views/systemrbac/permissions.vue'), // 权限管理
    'rbacrole': () => import('@/views/systemrbac/roles.vue'), // 角色管理
    'rbacdp': () => import('@/views/systemrbac/dpmodel.vue'), // 数据权限
    'reimburse': () => import('@/views/system/Reimburse.vue'), // 报销管理
    'AskForLeave': () => import('@/views/system/AskForLeave.vue'), // 请假管理
    'Setting': () => import('@/views/system/Setting.vue'), // 后台配置
    'Robots': () => import('@/views/robots/robotsList.vue'), // 机器人管理
    'wxmsgLog': () => import('@/views/robots/wxmsgLogList.vue'), // 催款机器人发的消息日志
    'Peer': () => import('@/views/addressBook/Peer.vue'), // 同行通讯录
    'Work': () => import('@/views/addressBook/Work.vue'), // 工作通讯录
    'AuthCode': () => import('@/views/addressBook/AuthCode.vue'), // 验证码
    'couponuselist': () => import('@/views/coupons/couponUseList.vue'), // 优惠券管理
    'couponlist': () => import('@/views/coupons/list.vue'), // 优惠券模型管理
    'annualSingle': () => import('@/views/annualInspection/singleList.vue'), // 工商年检-单独年检
    'annualBatch': () => import('@/views/annualInspection/batchList.vue'), // 工商年检-批量年检
    'annualDetail': () => import('@/views/annualInspection/annualList.vue'), // 平台年检情况
    'yichanglogList': () => import('@/views/annualInspection/yichanglogList.vue'), // 平台异常情况
    'NewsCat': () => import('@/views/systemNotice/NewsCat.vue'), //  新闻分类
    'NewsCenter': () => import('@/views/systemNotice/NewsCenter.vue'), // 新闻中心
    'logManagement': () => import('@/views/log/logManagement.vue'), // 总日志查看
    'statusManagement': () => import('@/views/log/statusManagement.vue'), // 总状态查看
    'signatureStatusManagement': () => import('@/views/log/signatureStatusManagement.vue'), // 签字状态查看
    'loginLog': () => import('@/views/log/loginLog.vue'), // 登录日志
    'logisticslog': () => import('@/views/log/logisticslog.vue'), // 邮寄台账
    'formalZipList': () => import('@/views/log/formalZipList.vue'), // 租赁合同台账
    'customerChat': () => import('@/views/log/customerChat.vue'), // 微信沟通记录
    'usbphonecall': () => import('@/views/log/usbphonecall.vue'), // 电话机拨号记录
    'usbphonesms': () => import('@/views/log/usbphonesms.vue'), // 电话机短信记录
    'robotsbatch': () => import('@/views/log/robotsbatch.vue'), // 批处理日志
    'DzhAccount': () => import('@/views/dzhAccount/list.vue'), // 登录日志
    'TelCheckCenter': () => import('@/views/action/TelCheckCenter.vue'), // 小工具-实名认证
    'WechatAutoCenter': () => import('@/views/wechatAuto/list.vue'), // 小工具-微信发广告
    'uploadrealpicture': () => import('@/views/kezhangManagement/uploadRealPicture.vue'), // 上传实物交付图
    'kezhangManagement': () => import('@/views/kezhangManagement/List.vue'), // 刻章管理
    'KezhangPlatform': () => import('@/views/kezhangManagement/KezhangPlatformList.vue'), // 刻章平台
    'KezhangPrice': () => import('@/views/kezhangManagement/KezhangPriceList.vue'), // 刻章价格
    'FwsPlatform': () => import('@/views/system/FwsPlatformList.vue'), // 服务商平台
    'storeCang': () => import('@/views/store/storeCangList.vue'), // 存储仓管理
    'specificProject': () => import('@/views/action/SpecificProject.vue'),//专项行动-项目管理
    'mailingAddress': () => import('@/views/personal/mailingAddress.vue'),//个人中心-我的寄件地址
    'tuiguang': () => import('@/views/tuiguang/tuiguang.vue'),//个人中心-我的推广
    'xiansuo': () => import('@/views/xiansuo/xiansuoList.vue'),//个人中心-我的线索
    'PersonalRobots': () => import('@/views/personal/PersonalRobots.vue'),
    'logistics_rule': () => import('@/views/system/logistics_rule.vue'), // 快递账号管理

}
/**
 * 基础路由
 * 2024-11-28
 * @type { *[] }
 */
export const constantRouterMap = [
    {
        path: '/user',
        name: 'user',
        component: UserLayout,
        redirect: '/user/login',
        hidden: true,
        children: [
            {
                path: 'login',
                name: 'login',
                component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login.vue'),
                meta: { title: '登录' }
            },
        ]
    },
    {
        path: '/mobilepage',
        name: 'mobilepage',
        component: () => import('@/layouts/BasicLayout.vue'),
        redirect: '/kezhangClient',
        children: [
            {
                path: '/kezhangClient',
                name: 'kezhangClient',
                component: () => import('@/views/kezhangClient/List.vue'),
                meta: { title: '刻章服务' }
            },
        ]
    },
    {
        path: '/Action_customer',
        name: 'Action_customer',
        component: () => import('@/views/action/Action.vue'),
        meta: { title: '特别行动' }
    },
    {
        path: '/kezhangmm',
        name: 'kezhangmm',
        component: () => import('@/views/kezhangManagement/uploadRealPicture.vue'),
        meta: { title: '刻章拍照' }
    },
    {
        path: '/exception/500',
        name: 'error',
        component: errorPage,
    },
    {
        path: '/:path(.*)',
        name: 'NoMatch',
        component: () => import('@/views/exception/404.vue'),
    }
]
